// Row types of the aircraft form's photo, blackout-range and peak-uplift lists, and the row updaters.
import type { Dayjs } from 'dayjs';

export type Range = { fromDate: Dayjs | null; toDate: Dayjs | null; reason?: string };
export type Photo = { url: string };
export type Uplift = { fromDate: Dayjs | null; toDate: Dayjs | null; multiplier: number | null };

export function updateRange(
  setRanges: React.Dispatch<React.SetStateAction<Range[]>>,
  i: number,
  patch: Partial<Range>,
) {
  setRanges((rs) => rs.map((r, j) => (j === i ? { ...r, ...patch } : r)));
}

export function updateUplift(
  setUplifts: React.Dispatch<React.SetStateAction<Uplift[]>>,
  i: number,
  patch: Partial<Uplift>,
) {
  setUplifts((us) => us.map((u, j) => (j === i ? { ...u, ...patch } : u)));
}
